import React, { useEffect, useState } from 'react';
import Loader from 'react-loaders';
import { useStateSelector } from '../../store/selectors';
import './DocumentSign.scss';

interface DocumentSignProps {
    documentId: number;
    onDocumentSign: () => void;
}
export const DocumentSign = (props: DocumentSignProps) => {
    const [isLoading, setIsLoading] = useState(true);
    const [embedUrl, setEmbedUrl] = useState('');
    const axios = useStateSelector((state) => state.core.axios);
    let pollingInterval: NodeJS.Timeout = null;

    useEffect(() => {
        setIsLoading(true);
        axios
            .get(`/api/SignDocuments/${props.documentId}/signUrl`)
            .then((response) => {
                setEmbedUrl(response.data);
            })
            .finally(() => setIsLoading(false));
    }, [props.documentId]);

    useEffect(() => {
        if (embedUrl) {
            pollingInterval = setInterval(() => {
                checkIfSigned();
            }, 5000);
            return () => {
                clearInterval(pollingInterval);
            };
        }
    }, [embedUrl]);

    const checkIfSigned = () => {
        axios
            .get(`/api/SignDocuments/${props.documentId}/sign`)
            .then((response) => {
                if (response.data) {
                    clearInterval(pollingInterval);
                    props.onDocumentSign();
                }
            });
    };

    const renderLoader = () => {
        return (
            <div className="loader-container" style={{ width: 'inherit' }}>
                <div className="loader-container-inner">
                    <div className="text-center">
                        <Loader active={isLoading} type="ball-scale-multiple" />
                    </div>
                    <h6 className="mt-5">Loading...</h6>
                </div>
            </div>
        );
    };

    return isLoading ? (
        renderLoader()
    ) : (
        <div className="document-sign">
            <iframe
                title="Referral Partner Agreement Signing"
                src={embedUrl}></iframe>
        </div>
    );
};
